import { SupportedLanguageCodes } from '@app-static-data/languages';

export class ClientConfigResponse {
  status: string;
  captcha: Captcha;
  captchaRequired: boolean;
  programName: string;
  isProgramSSO: string;
  programMake: string;
  userSSOSuffix: string;
  programId: string;
  clientInfo: ClientInfo;
  applicationId: string;
  loginBox: LoginBox;
  multilingual: string;
  leftJustify: boolean;
  languageCode: SupportedLanguageCodes;
  css: CSS;
  images: any;
  imageIds: ImageId[];
  languages: { name: string; code: string }[];

  constructor() {
    this.css = new CSS();
    this.images = new Images();
    this.captcha = new Captcha();
    this.captchaRequired = false;
    this.imageIds = [];
    this.languages = [];
  }
}

export class CSS {
  logoBkgrdColor: string;
  primaryColor: string;
  secondaryColor: string;
  brandBarColor: string;
  fontColor: string;
  buttonColor: string;
  emulateBanner: EmulateBanner;

  constructor() {
    this.emulateBanner = new EmulateBanner();
  }
}

export class EmulateBanner {
  bkgrdColor: string;
  fontColor: string;

  constructor() {
    this.bkgrdColor = '#FF7A7A';
    this.fontColor = '#FFFFFF';
  }
}

export class LoginBox {
  boldTitle: boolean;
  leftJustify: boolean;
}

export class ClientInfo {
  title: string;
  text: string;
}

export class Images {
  loginPageBackground: string;
  logo: string;
  logoMiddle: string;
  logoRight: string;
  navbarLogo: string;
  homePageLinks: string;
}

export class Captcha {
  data: string;
  text: string;
  required: boolean;
  encText: string;
}

export class ImageId {
  imageName: string;
  imageId: string;
  image: any;
}
